/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import ArtifactsAuditList from './List/artifact';
import { ProtectedRouter } from 'infrastructure/routing';
import { Route, createRoute } from 'framework/routing';
import { READ_SECURITY_AUDIT_LOG } from './shared/auditService';
import RoleAssignmentsList from './List/roles';
import PermissionsConfigurationList from './List/permissions';

const AUDIT_PATH = '/audit';
export const ROLES_AUDIT_PATH = '/audit/roles';
export const PERMISSIONS_AUDIT_PATH = '/audit/permissions';
export const ARTIFACTS_AUDIT_PATH = '/audit/artifacts';

const useAuditRoutes = () => {
  const baseRoutes = createRoute({ listRoute: AUDIT_PATH });

  return {
    ...baseRoutes,
    rolesRoute: `${baseRoutes.listRoute}/roles`,
    permissionsRoute: `${baseRoutes.listRoute}/permissions`,
    artifactsRoute: `${baseRoutes.listRoute}/artifacts`,
  };
};

const AuditRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { rolesRoute, permissionsRoute, artifactsRoute } = useAuditRoutes();

  return (
    <ProtectedRouter basePath={AUDIT_PATH}>
      <Routes>
        <Route
          path={rolesRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_SECURITY_AUDIT_LOG}>
              <RoleAssignmentsList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={permissionsRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_SECURITY_AUDIT_LOG}>
              <PermissionsConfigurationList />
            </GlobalProtectedRoute>
          }
        />

        <Route
          path={artifactsRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_SECURITY_AUDIT_LOG}>
              <ArtifactsAuditList />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

AuditRouter.getRouterPath = () => `${AUDIT_PATH}/*`;

export default AuditRouter;
